module.exports = __webpack_public_path__ + "img/logo.4b36d122.png";